import { render } from "./FeatherIcon.vue?vue&type=template&id=58fd9a31"
import script from "./FeatherIcon.vue?vue&type=script&lang=js"
export * from "./FeatherIcon.vue?vue&type=script&lang=js"

import "./FeatherIcon.vue?vue&type=style&index=0&id=58fd9a31&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__